import { array, InferType, lazy, number, object, string } from "yup";

export const colorTheme = object({
    primaryColor: string().default("#000000"),
    secondaryColor: string().default("#000000"),
    tertiaryColor: string().default("#000000"),
});

const keywordSchema = object({
    FR: array(string()),
    DE: array(string()),
    UK: array(string()),
    ES: array(string()),
    IT: array(string()),
    AT: array(string()),
});

const UpsertCategoriesSchema = lazy((obj) =>
    object(Object.fromEntries(Object.keys(obj || {}).map((key) => [key, string().required()])))
);

const categoriesSchema = lazy((obj) =>
    object(
        Object.fromEntries(
            Object.keys(obj || {}).map((key) => [key, array().of(string()).required()])
        )
    )
);

export const ThematicSchema = object({
    id: number().required(),
    name: string()
        .required("error.thematic.name.required")
        .min(3, "error.thematic.name.min")
        .max(50, "error.thematic.name.max"),
    comment: string().optional().max(500, "error.thematic.comment.max"),
    colorThemes: array().of(colorTheme).notRequired(),
    websites: keywordSchema.notRequired(),
    keywords: keywordSchema.notRequired(),
    categories: categoriesSchema,
});

export type ThematicListOptions = {
    value: number;
    label: string;
};

const keywordSchemaDto = object({
    FR: string(),
    DE: string(),
    UK: string(),
    ES: string(),
    IT: string(),
    AT: string(),
});

export const ThematicDTOSchema = ThematicSchema.pick(["name", "comment", "colorThemes"]).concat(
    object({
        keywords: keywordSchemaDto.notRequired(),
        websites: keywordSchemaDto.notRequired(),
        categories: UpsertCategoriesSchema,
    })
);

export const UpsertThematicDTOSchema = ThematicSchema.omit(["id"]);

export type Thematic = InferType<typeof ThematicSchema>;
export type ThematicDto = InferType<typeof ThematicDTOSchema>;
export type ColorTheme = InferType<typeof colorTheme>;
